export const DEFAULT_PRICING = {
  CA: { currency: 'cad', pricePerTransactionDollars: 1 },
  US: { currency: 'usd', pricePerTransactionDollars: 1 },
  OTHER: { currency: 'usd', pricePerTransactionDollars: 1 },
};

export function normalizeCountryCode(input) {
  if (input == null || input === '') {
    return null;
  }
  const normalized = String(input).trim().toUpperCase();
  if (normalized === 'CA' || normalized === 'CAN' || normalized === 'CANADA') {
    return 'CA';
  }
  if (
    normalized === 'US' ||
    normalized === 'USA' ||
    normalized === 'UNITED STATES' ||
    normalized === 'UNITED STATES OF AMERICA'
  ) {
    return 'US';
  }
  return 'OTHER';
}

export function resolvePricingForCountry(storeCountry) {
  const countryCode = normalizeCountryCode(storeCountry) || 'OTHER';
  const pricing = DEFAULT_PRICING[countryCode] || DEFAULT_PRICING.OTHER;
  return {
    countryCode,
    currency: pricing.currency,
    pricePerTransactionDollars: pricing.pricePerTransactionDollars,
    regionLabel:
      countryCode === 'CA'
        ? 'Canada'
        : countryCode === 'US'
          ? 'United States'
          : 'International',
  };
}

export function applyBillingProfile(profile) {
  if (!profile) {
    return null;
  }
  cachedBillingProfile = {
    countryCode: profile.countryCode || null,
    currency: profile.currency || null,
    pricePerTransactionDollars:
      typeof profile.pricePerTransactionDollars === 'number'
        ? profile.pricePerTransactionDollars
        : null,
    regionLabel: profile.regionLabel || null,
  };
  return cachedBillingProfile;
}

let cachedBillingProfile = null;

export function getCachedBillingProfile() {
  return cachedBillingProfile;
}

export function clearCachedBillingProfile() {
  cachedBillingProfile = null;
}

export function getRegionalPricingFromConfig(config) {
  if (config?.regionalPricing) {
    return config.regionalPricing;
  }
  return DEFAULT_PRICING;
}
